import { useEffect, useState, useCallback, useRef, MutableRefObject, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, MenuProps, message, Popover, Select } from 'antd';
import { Button, Space, Row, Col, Modal, Input, Spin } from 'antd';
import dayjs from 'dayjs';
import closeIcon from '@/assets/images/Icons_Cross.png';
import { useAppSelector } from '@/store/hooks';
import debounce from 'lodash.debounce';
import api from '@/api/customer';
import Pagination from '@/components/pagination';
import { defaultInfo } from '@/typings/allType';
import { setChatUser } from '@/store/stateSlice';
import { useDispatch } from 'react-redux';
import publicMethod, { disabledDate } from '@/utils/publicMethod';
import { useActivate, useAliveController } from 'react-activation';
import useDownLoadCSV from '@/hook/useDownLoadCSV';
import { calendarIcon, searchIcon } from '@/constants/static';
const Customer = props => {
    const link = useNavigate();
    const { RangePicker } = DatePicker;
    const [loading, setLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(true);
    const [totalRecord, setTotalRecord] = useState(0);
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        keyword: '',
    });
    const [customerNum, setCustomerNum] = useState('0');
    const [customerTotal, setCustomerTotal] = useState('0.00');
    const [tableData, setTableData] = useState<any[]>([]);
    const inputChange = e => {
        setListParams(state => ({ ...state, keyword: e.target.value, pageNum: 1 }));
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => getCustomers(nextValue), 1500),
        []
    );
    async function getCustomers(params) {
        console.log(listParams);
        setLoading(true);
        if (params.pageNum === 1) {
            setFirstLoading(true);
        }
        try {
            const res = await api.getCustomerList(params);
            const list = res.data.records.map(item => {
                return Object.assign(item, {
                    createTime: item.createTime ? window.utils.formatTimeMDY(item.createTime) : '-',
                    mobile: item.mobile ? window.utils.formatMobileNumber(item.mobile) : '-',
                    gender: item.gender === 1 ? 'Male' : item.gender === 2 ? 'Female' : 'Non-Binary',
                });
            });
            setTableData(list);
            setTotalRecord(+res.data.total);
            setCustomerNum(window.utils.formatNum(res.data.total));
            setCustomerTotal(res.data.metaData);
        } catch (error: any) {
            message.error(error);
        } finally {
            setFirstLoading(false);
            setLoading(false);
        }
    }
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
        getCustomers({ ...listParams, pageNum: prop });
    };
    useEffect(() => {
        getCustomers(listParams);
    }, []);
    const dateOnChange = date => {
        getCustomers({
            ...listParams,
            pageNum: 1,
            startTime: date ? dayjs(`${dayjs(date[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString() : '',
            endTime: date ? dayjs(`${dayjs(date[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString() : '',
        });
        setListParams({
            ...listParams,
            pageNum: 1,
            startTime: date ? dayjs(`${dayjs(date[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString() : '',
            endTime: date ? dayjs(`${dayjs(date[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString() : '',
        });
    };
    const handleChange = (value: string, item: defaultInfo) => {
        console.log(`selected ${value}`);
        const pat = {
            customerId: item.customerId,
            isDisable: value === 'Inactive',
        };
        if (value === 'Inactive') {
            setAccountModal({ open: true, disable: true, id: item.customerId, type: 1 });
            return;
        }
        changeStuatus(pat);
    };
    const changeStuatus = async (pat: defaultInfo) => {
        try {
            await api.changeCustomerStatus({ ...pat });
            getCustomers(listParams);
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
        } catch (error: any) {
            message.error(error);
        }
    };
    const delCustomer = async (pat: defaultInfo) => {
        try {
            await api.deleteCustomer({ ...pat });
            getCustomers(listParams);
            setAccountModal({ open: false, disable: false, id: '', type: 1 });
        } catch (error: any) {
            message.error(error);
        }
    };
    const [accountModal, setAccountModal] = useState({ disable: false, open: false, id: '', type: 1 });
    const [visiblePop, setVisiblePop] = useState(-1);
    const dispatch = useDispatch();
    const { drop } = useAliveController();
    useActivate(() => {
        drop('CustomerDetails');
    });

    const exportFileName = useMemo(() => {
        const { startTime, endTime } = listParams;
        if (!startTime || !endTime) {
            return 'Customer List (All).csv';
        } else {
            return `Customer List (${dayjs(startTime).format('MMMM D, YYYY')} - ${dayjs(endTime).format(
                'MMMM D, YYYY'
            )}).csv`;
        }
    }, [listParams]);

    const { downloadCSV } = useDownLoadCSV(exportFileName);

    const handleExportCSV = async () => {
        const res = await api.getCustomerList({ ...listParams, pageNum: 1, pageSize: -1 });
        const data = res.data.records.map(item => {
            return {
                'Full Name': item.fullName,
                Email: item.email,
                Mobile: window.utils.formatMobileNumber(item.mobile),
                Gender: item.gender === 1 ? 'Male' : item.gender === 2 ? 'Female' : 'Non-Binary',
                'Tasks Completed': item.tasksCompleted,
            };
        });
        data.unshift({
            'Full Name': 'Full Name',
            Email: 'Email',
            Mobile: 'Mobile',
            Gender: 'Gender',
            'Tasks Completed': 'Tasks Completed',
        });
        downloadCSV(data);
    };
    const popupContainer = document.getElementById('select-bar') || document.body;
    return (
        <>
            <div className="page-main account">
                <div className="page-title">Customer</div>
                <div className="select-bar" id="select-bar">
                    <div className="select-bar-left">
                        <RangePicker
                            className="search-input"
                            placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                            suffixIcon={calendarIcon}
                            separator={'-'}
                            format={'DD/MM/YYYY'}
                            disabledDate={disabledDate}
                            onChange={dateOnChange}
                            getPopupContainer={() => popupContainer}
                        />
                        <Input
                            className="search-input"
                            placeholder="Search by name"
                            onChange={inputChange}
                            prefix={searchIcon}
                        />
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        style={{
                            height: 46,
                            width: 128,
                            borderRadius: 8,
                            justifySelf: 'flex-end',
                        }}
                        onClick={handleExportCSV}
                    >
                        Export
                    </Button>
                </div>
                {!firstLoading ? (
                    <div className="page-total">
                        <div className="total-item">
                            Total number of customers<span>{customerNum ?? 0}</span>
                        </div>
                        <div className="total-item">
                            Total Payment Amount
                            <span>${customerTotal ? publicMethod.formatPrice(customerTotal) : '0.00'}</span>
                        </div>
                    </div>
                ) : (
                    ''
                )}
                {loading ? (
                    <div className="data_loading flex-center">
                        <Spin />
                    </div>
                ) : (
                    <>
                        <div className="table">
                            {totalRecord ? (
                                <>
                                    <div className="table-th">
                                        <Row>
                                            <Col span={3}>Full Name</Col>
                                            <Col span={4}>Email</Col>
                                            <Col span={2}>Gender</Col>
                                            <Col span={3}>Mobile</Col>
                                            <Col span={4}>Tasks Completed</Col>
                                            <Col span={4}>Regisisted Date</Col>
                                            <Col span={3}>Status</Col>
                                            <Col span={1}></Col>
                                        </Row>
                                    </div>
                                    {tableData.map((item, index) => (
                                        <Row className="table-tr" key={item.customerId}>
                                            <Col
                                                span={3}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    window.sessionStorage.setItem('customerInfo', JSON.stringify(item));
                                                    link('/customer/detail');
                                                }}
                                            >
                                                {item.fullName}
                                            </Col>
                                            <Col span={4}>{item.email ?? '-'}</Col>
                                            <Col span={2}>{item.gender}</Col>
                                            <Col span={3}>{item.mobile}</Col>
                                            <Col span={4}>{item.tasksCompleted ?? '0'}</Col>
                                            <Col span={4}>{item.createTime ?? '-'}</Col>
                                            <Col span={3}>
                                                <Select
                                                    className={
                                                        item.disabled
                                                            ? 'select-input select-disable'
                                                            : 'select-input select-enable'
                                                    }
                                                    defaultValue="Active"
                                                    style={{ width: 88 }}
                                                    onChange={val => {
                                                        handleChange(val, item);
                                                    }}
                                                    value={item.disabled ? 'Inactive' : 'Active'}
                                                    options={[
                                                        { value: 'Active', label: 'Active' },
                                                        { value: 'Inactive', label: 'Inactive' },
                                                    ]}
                                                    suffixIcon={
                                                        <img
                                                            src={require('@/assets/images/selected.png')}
                                                            style={{ width: 16, height: 16 }}
                                                        />
                                                    }
                                                />
                                            </Col>
                                            <Col span={1}>
                                                <Popover
                                                    open={visiblePop === index}
                                                    onOpenChange={v => setVisiblePop(v ? index : -1)}
                                                    placement="bottomRight"
                                                    content={
                                                        <div className="view-more">
                                                            <div
                                                                onClick={() => {
                                                                    setVisiblePop(-1);
                                                                    window.sessionStorage.setItem(
                                                                        'customerInfo',
                                                                        JSON.stringify(item)
                                                                    );
                                                                    link('/customer/detail');
                                                                }}
                                                            >
                                                                Details
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    setVisiblePop(-1);
                                                                    link('/user/chat');
                                                                    dispatch(
                                                                        setChatUser({
                                                                            chatUserId: item.customerId,
                                                                            chatuserIdentity: 'Customer',
                                                                            chatUserName: item.fullName,
                                                                        })
                                                                    );
                                                                }}
                                                            >
                                                                DM
                                                            </div>
                                                            <div
                                                                onClick={() => {
                                                                    setVisiblePop(-1);
                                                                    setAccountModal({
                                                                        disable: false,
                                                                        open: true,
                                                                        id: item.customerId,
                                                                        type: 2,
                                                                    });
                                                                }}
                                                            >
                                                                Delete
                                                            </div>
                                                        </div>
                                                    }
                                                >
                                                    <img
                                                        style={{
                                                            width: 24,
                                                            height: 24,
                                                            cursor: 'pointer',
                                                            textAlign: 'right',
                                                        }}
                                                        src={require('@/assets/images/view-more.png')}
                                                        alt=""
                                                    />
                                                </Popover>
                                            </Col>
                                        </Row>
                                    ))}
                                    <Pagination
                                        total={totalRecord}
                                        pageChange={handlePageChange}
                                        pageNo={listParams.pageNum}
                                    />
                                </>
                            ) : (
                                <div className="no-data flex-center">No data</div>
                            )}
                        </div>
                    </>
                )}
            </div>
            <Modal width={560} maskClosable={false} centered={true} open={accountModal.open} closeIcon={<></>}>
                <div className="modal-title">{accountModal.type === 1 ? 'Disabled account' : 'Delete account'}</div>
                <div className="modal-tip tip-font-20">
                    {accountModal.type === 1
                        ? 'Are you sure you want to disable this account?'
                        : 'Are you sure you want to delete this account?'}
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button
                        className="submit-btn"
                        onClick={() => {
                            setAccountModal({ disable: false, open: false, id: '', type: 1 });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="submit-btn"
                        type="primary"
                        onClick={() => {
                            accountModal.type === 1
                                ? changeStuatus({
                                      customerId: accountModal.id,
                                      isDisable: true,
                                  })
                                : delCustomer({ customerId: accountModal.id });
                        }}
                    >
                        {accountModal.type === 1 ? 'Yes' : 'Yes, delete'}
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default Customer;
